<main class="full-height d-flex flex-column justify-content-center text-center container">
  <div class="row">
    <div class="col-8 offset-2 col-md-6 offset-md-3 col-lg-4 offset-lg-4 form-group text-center">
      <div class="loading-indicator">
        <img i18n-alt alt="Loading" src="{{ getLogoPath() }}" />
      </div>
    </div>
  </div>
</main>
